import React from 'react';

export const PersonIcon: React.FC = () => (
	<svg width='2rem' height='2rem' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<circle cx='9.99691' cy='4.84847' r='4.09847' stroke='currentColor' strokeWidth='1.5' />
		<path d='M18.913 19.25H1.08104C1.46201 14.6597 5.30831 11.0531 9.997 11.0531C14.6857 11.0531 18.532 14.6597 18.913 19.25Z' stroke='currentColor' strokeWidth='1.5' />
	</svg>
);
